exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-img[data-v-2d09e79f]{position:relative;margin-bottom:20px}.audio-img img[data-v-2d09e79f]{height:450px;width:100%;display:block;-o-object-fit:cover;object-fit:cover}.audio-img .audio-bar[data-v-2d09e79f]{position:absolute;left:0;right:0;bottom:0}.audio-img .audio-bar .audio-e[data-v-2d09e79f]{padding:20px}.tool-bar[data-v-2d09e79f]{margin-bottom:10px}", ""]);

// exports
